import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation13({ animation, badge, all_animations }: Props) {
  const [flash, setFlash] = useState(false)
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setFlash(true), 100)
    setTimeout(() => setFlash(false), 300)
    setTimeout(() => setFlash(true), 400)
    setTimeout(() => setFlash(false), 500)
    setTimeout(() => setShowBadge(true), 500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes revealFromLight {
          0% {
            opacity: 0;
            filter: blur(20px) brightness(3);
            transform: scale(1.5);
          }
          100% {
            opacity: 1;
            filter: blur(0) brightness(1);
            transform: scale(1);
          }
        }
        @keyframes lightRays {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .reveal-from-light {
          animation: revealFromLight 1s ease-out forwards;
        }
        .light-rays {
          animation: lightRays 10s linear infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh] relative">
        {/* Flash overlay */}
        <div
          className={`fixed inset-0 bg-tessan-cream pointer-events-none transition-opacity duration-100 z-50 ${flash ? 'opacity-80' : 'opacity-0'}`}
        />

        {/* Rayons de lumière */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="light-rays w-[800px] h-[800px]">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className="absolute left-1/2 top-1/2 w-1 h-[400px] bg-gradient-to-t from-transparent via-tessan-yellow/30 to-transparent origin-bottom"
                style={{ transform: `translateX(-50%) rotate(${i * 30}deg)` }}
              />
            ))}
          </div>
        </div>

        {/* Badge avec effet de lumière */}
        <div className={`relative z-10 ${showBadge ? 'reveal-from-light' : 'opacity-0'}`}>
          {/* Glow derrière */}
          <div className="absolute inset-0 blur-3xl bg-tessan-yellow/50 scale-150 rounded-2xl" />

          {/* Badge */}
          <div className="relative w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-700 delay-700 ${showBadge ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
